import {Component, Input, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {DefaultSettingsService} from '../../default-settings-service.service';

@Component({
  selector: 'result-waffle',
  templateUrl: './result-waffle.component.html',
  styles: []
})
export class ResultWaffleComponent extends ExcTranslation implements OnInit {

  @Input('Results') Results;
  constructor(private excDss: DefaultSettingsService) {
    super();
  }

  ngOnInit() {
  }

}
